import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { airportcity, airportregions, getHost, populatePost, views } from "./utils";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

export const getAdvertising = createAsyncThunk("properties/getadvertising", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/getadvertising", {
      ...payload,
      ...state.search,
      url: document.location.href,
      hotelcount: state.filter.hotelCount,
      request:
        state.system.view === views.tileview || state.system.view === views.confirmationview || state.system.view === views.bookingview || state.system.view === views.searchview
          ? {}
          : populatePost(
              state.search.selectedDestination,
              {
                ...state.search,
                promosession: state.system.sessionId,
                offset: 0,
                amount: 0,
              },
              state.properties.departureStations,
            ),
      offerid: state.hotel.offerId,
      hotel: state.hotel.selectedHotel,
      agencyid: window.configData.AGENCYID,
      sessionid: state.system.sessionId,
    });

    if (payload?.panel && document.getElementById(payload.panel)) {
      document.getElementById(payload.panel).innerHTML = response.data;
    }
    //console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkAddressOrEmail = createAsyncThunk("properties/checkAddressOrEmail", async (payload, thunkAPI) => {
  let parms = "";
  if (payload.customerCity) parms = parms + "&customerCity=" + encodeURIComponent(payload.customerCity);
  if (payload.customerStreet) parms = parms + "&customerStreet=" + encodeURIComponent(payload.customerStreet);

  //ACHTUNG property name gewechselt wegen checkaddress
  if (payload.customerCountryCode) parms = parms + "&customerCountry=" + encodeURIComponent(payload.customerCountryCode);

  if (payload.customerPostalCode) parms = parms + "&customerPostalCode=" + encodeURIComponent(payload.customerPostalCode);

  if (payload.customerEmail) parms = parms + "&customerEmail=" + encodeURIComponent(payload.customerEmail);

  try {
    const response = await axios.get(getHost() + "/checkaddress?agencyid=" + window.configData.AGENCYID + parms);

    return response.data?.data;
  } catch (error) {
    const d = error?.response?.data?.data;
    if (d) return d;
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkIban = createAsyncThunk("properties/checkIban", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/checkiban?agencyid=" + window.configData.AGENCYID + "&iban=" + encodeURIComponent(payload.iban));

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

// IBAN-Validierung via pyserver /validateiban (sepatools). Prueft NUR die
// IBAN-Gueltigkeit (kein BIC noetig - alter Kram). Liefert {valid,bic,bank}.
export const validateIban = createAsyncThunk("properties/validateIban", async (payload, thunkAPI) => {
  const mapResult = (d) => ({ valid: !!(d && d.valid), bic: (d && d.bic) || "", bank: (d && d.bank_name) || "" });
  try {
    const response = await axios.get(getHost() + "/validateiban?iban=" + encodeURIComponent(payload.iban));
    return mapResult(response.data?.data);
  } catch (error) {
    // 400 = ungueltige IBAN: Body enthaelt trotzdem data.valid=false
    const d = error?.response?.data?.data;
    if (d) return mapResult(d);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getBestplaces = createAsyncThunk("properties/getBestplaces", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/getbestplaces?agencyid=" + window.configData.AGENCYID + "&target=mobile&typ=package&language=de");

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getInfos = createAsyncThunk("properties/getInfos", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/getinfos?agencyid=" + window.configData.AGENCYID + "&context=" + encodeURIComponent(payload.context) + "&language=de");

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchRegionGroups = createAsyncThunk("properties/fetchRegionGroups", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/inventoryDataForPackage?parameter=TouristicRegions");

    //console.log(response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchDepartureStations = createAsyncThunk("properties/fetchDepartureStations", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/inventoryDataForPackage?parameter=DepartureStations");

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchTourOperators = createAsyncThunk("properties/fetchTourOperators", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/inventoryDataForPackage?parameter=TourOperator");
    //console.log(response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchTravelAgencies = createAsyncThunk("properties/travelAgencies", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/travelagencies2");

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchSessionHistory = createAsyncThunk("properties/fetchSessionHistory", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/getsessionhistory?sessionid=" + payload.sessionid);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const deletesessionhistory = createAsyncThunk("properties/deletesessionhistory", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();
  try {
    const response = await axios.get(getHost() + "/deletesessionhistory?id=" + payload.id + "&sessionid=" + state.system.sessionId);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchSuggestions = createAsyncThunk("properties/suggestions", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();
  try {
    const response = await axios.get(getHost() + "/getsuggestions?sessionid=" + state.system.sessionId + "&agencyid=" + window.configData.AGENCYID);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchAirlines = createAsyncThunk("properties/fetchAirlines", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/inventoryDataForPackage?parameter=TransportOperatingBrand");
    //console.log(response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchAirlineProperties = createAsyncThunk("properties/fetchairlineproperties", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/fetchairlineproperties");
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

/*export const fetchAgencyproperties = createAsyncThunk("properties/agencyproperties", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/agencyproperties?id=" + window.configData.AGENCYID);

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});*/

export const fetchAgency = createAsyncThunk("properties/agency", async (payload, thunkAPI) => {
  try {
    // Skip API call wenn PHP bereits agencyproperties injiziert hat (WP Search Widget)
    if (
      window.configData?.agencyproperties &&
      typeof window.configData.agencyproperties === 'object' &&
      Object.keys(window.configData.agencyproperties).length > 0
    ) {
      return window.configData.agencyproperties;
    }

    const response = await axios.get(getHost() + "/agency?id=" + window.configData.AGENCYID);

    if (typeof response.data.data.ibeProvider === "object") {
      response.data.data.ibeProviderTag = response.data.data.ibeProvider.provider;
    } else if (typeof response.data.data.ibeProvider === "string") {
      response.data.data.ibeProviderTag = response.data.data.ibeProvider;
    }

    return response.data.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

// Nicht jeder Provider unterstuetzt die Abflugtag-Einschraenkung (weekPreset +
// weekdays, siehe DatePopUp.jsx) - der Wochentag-Selector darf im Client nur
// auftauchen, wenn ALLE fuer die Agentur konfigurierten Provider sie unterstuetzen
// (Server-Check in ibe_server/providers/index.js getWeekdaySupport).
export const fetchProviderCapabilities = createAsyncThunk("properties/providerCapabilities", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/providerCapabilities");
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const fetchHolidays = createAsyncThunk("properties/holidays", async (payload, thunkAPI) => {
  try {
    // Hole Schulferien + Feiertage für laufendes und nächstes Jahr
    const pyApiUrl = getHost();
    const currentYear = new Date().getFullYear();
    const response = await axios.get(pyApiUrl + `/searchholidays?year=${currentYear}`);
    const responseNext = await axios.get(pyApiUrl + `/searchholidays?year=${currentYear + 1}`);

    // Hole auch Bundesländer für Dropdown
    const statesResponse = await axios.get(pyApiUrl + "/searchholidays/bundeslaender");

    // Helper: Flatten holidays from object format { "DE-BY": [...], "DE-BE": [...] } to array
    // API returns items keyed by ISO code, we need to add iso_codes to each holiday
    const flattenHolidaysFromObject = (items) => {
      if (!items || typeof items !== "object") return [];
      // If it's already an array, return as-is
      if (Array.isArray(items)) return items;
      // Otherwise it's an object keyed by state code
      const result = [];
      for (const [isoCode, holidays] of Object.entries(items)) {
        for (const holiday of holidays) {
          result.push({
            ...holiday,
            iso_codes: [isoCode],
            holiday_type: "school",
          });
        }
      }
      return result;
    };

    const holidaysYear1 = flattenHolidaysFromObject(response.data.data?.items || response.data.data);
    const holidaysYear2 = flattenHolidaysFromObject(responseNext.data.data?.items || responseNext.data.data);

    return {
      holidays: [...holidaysYear1, ...holidaysYear2],
      states: statesResponse.data.data?.items || statesResponse.data.data || [],
    };
  } catch (error) {
    console.log("[fetchHolidays] Error:", error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

const initialState = {
  regionGroups: [],
  departureStations: [],
  tourOperators: [],
  airlines: [],
  travelAgencies: [],
  bestplaces: [],
  infos: {},
  suggestions: [],
  ibanresult: {},
  addressresult: {},
  sessionHistory: [],
  agencyproperties: {},
  holidays: { publicHolidays: {}, schoolHolidays: {}, states: [] },
  // Default false, bis der Check da ist - ein Filter darf nicht kurz aufblitzen, um
  // dann wieder zu verschwinden, falls ein Provider ihn nicht unterstuetzt.
  providerCapabilities: { weekdays: false, railandfly: false, rentalcar: false, freecancellation: false, freerebook: false, addablecancellation: false, swimUpPool: false, multiroom: false },
};

export const propertiesSlice = createSlice({
  name: "properties",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(checkIban.fulfilled, (state, { payload }) => {
      state.ibanresult = payload.response;
    });
    builder.addCase(checkAddressOrEmail.fulfilled, (state, { payload }) => {
      state.addressresult = payload.response;
    });

    builder.addCase(fetchAirlineProperties.fulfilled, (state, { payload }) => {
      state.airlines = [
        ...state.airlines.map((e) => {
          let a = payload.ret.find((f) => e.value === f.id);
          return { ...e, properties: a ? a.properties : {} };
        }),
      ];
    });

    builder.addCase(getBestplaces.fulfilled, (state, { payload }) => {
      state.bestplaces = payload.ret;
    });

    builder.addCase(getInfos.fulfilled, (state, { payload, meta }) => {
      state.infos = { ...state.infos, [meta.arg.context]: payload?.data?.infotext || "" };
    });

    builder.addCase(fetchSessionHistory.pending, (state) => {
      state.sessionHistory = [];
    });
    builder.addCase(fetchSessionHistory.fulfilled, (state, { payload }) => {
      state.sessionHistory = payload.ret;
    });
    builder.addCase(deletesessionhistory.fulfilled, (state, { payload }) => {
      state.sessionHistory = payload.ret;
    });
    builder.addCase(fetchRegionGroups.pending, (state) => {
      state.regionGroups = [];
    });
    builder.addCase(fetchRegionGroups.fulfilled, (state, { payload }) => {
      state.regionGroups = payload.RegionGroups?.RegionGroup || [];
    });
    builder.addCase(fetchAgency.fulfilled, (state, { payload }) => {
      state.agencyproperties = payload;
    });

    builder.addCase(fetchProviderCapabilities.fulfilled, (state, { payload }) => {
      state.providerCapabilities = {
        weekdays: !!payload?.weekdays,
        railandfly: !!payload?.railandfly,
        rentalcar: !!payload?.rentalcar,
        freecancellation: !!payload?.freecancellation,
        freerebook: !!payload?.freerebook,
        addablecancellation: !!payload?.addablecancellation,
        swimUpPool: !!payload?.swimUpPool,
        multiroom: !!payload?.multiroom,
      };
    });

    builder.addCase(fetchHolidays.fulfilled, (state, { payload }) => {
      // Transformiere API-Daten in das Format das DatePopUp erwartet
      const publicHolidays = {};
      const schoolHolidays = {};

      for (const holiday of payload.holidays) {
        const year = holiday.year?.toString();
        const holidayType = holiday.holiday_type;

        if (holidayType === "public") {
          // Gesetzliche Feiertage nach Jahr gruppieren
          if (!publicHolidays[year]) {
            publicHolidays[year] = [];
          }
          // ISO-Codes zu short codes (DE-BY -> BY)
          const states = (holiday.iso_codes || []).map((code) => (code === "ALL" ? "ALL" : code.replace("DE-", "")));
          publicHolidays[year].push({
            date: holiday.date || holiday.start_date, // API gibt 'date' für public holidays
            name: holiday.holiday_name || holiday.label,
            states: states.length > 0 ? states : ["ALL"],
          });
        } else if (holidayType === "school") {
          // Schulferien nach Bundesland gruppieren
          for (const isoCode of holiday.iso_codes || []) {
            const shortCode = isoCode.replace("DE-", "");
            if (!schoolHolidays[shortCode]) {
              schoolHolidays[shortCode] = [];
            }
            // Deduplizierung: Prüfe ob diese ID bereits existiert
            const exists = schoolHolidays[shortCode].some((h) => h.id === holiday.id);
            if (!exists) {
              schoolHolidays[shortCode].push({
                id: holiday.id,
                start: holiday.start_date,
                end: holiday.end_date,
                name: holiday.holiday_name || holiday.label,
              });
            }
          }
        }
      }

      // Bundesländer für Dropdown
      const states = payload.states.map((s) => ({
        code: s.iso_code?.replace("DE-", "") || s.code,
        name: s.label || s.name,
      }));

      state.holidays = { publicHolidays, schoolHolidays, states };
    });

    builder.addCase(fetchAirlines.pending, (state) => {
      state.airlines = [];
    });
    builder.addCase(fetchAirlines.fulfilled, (state, { payload }) => {
      let oplines = [];
      if (Array.isArray(payload?.TransportOperatingBrands?.TransportOperatingBrand)) {
        for (let i = 0; i < payload.TransportOperatingBrands.TransportOperatingBrand.length; i++) {
          oplines.push({
            value: payload.TransportOperatingBrands.TransportOperatingBrand[i].Code,
            label: payload.TransportOperatingBrands.TransportOperatingBrand[i].Name,
          });
        }
      }
      state.airlines = oplines;
    });
    builder.addCase(fetchSuggestions.pending, (state) => {
      state.suggestions = [];
    });
    builder.addCase(fetchSuggestions.fulfilled, (state, { payload }) => {
      state.suggestions = payload;
    });
    builder.addCase(fetchTourOperators.pending, (state) => {
      state.tourOperators = [];
    });
    builder.addCase(fetchTourOperators.fulfilled, (state, { payload }) => {
      state.tourOperators = payload.TourOperators.TourOperator;
    });
    builder.addCase(fetchDepartureStations.pending, (state) => {
      state.departureStations = [];
    });
    builder.addCase(fetchDepartureStations.fulfilled, (state, { payload }) => {
      //console.log(payload);
      let dep = payload.Stations.DepartureStations.map((e) => {
        return { value: e, label: airportcity(e) };
      });

      state.departureStations = [...airportregions(), ...dep];
    });
    builder.addCase(fetchTravelAgencies.pending, (state) => {
      state.departureStations = [];
    });
    builder.addCase(fetchTravelAgencies.fulfilled, (state, { payload }) => {
      //console.log(payload);
      state.travelAgencies = { ...payload };
    });
  },
});

export default propertiesSlice.reducer;
